import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import {
    Table, TableBody, TableCell, TableHead, TablePagination, TableRow,
    TableSortLabel, Tooltip, TextField, Input, InputLabel, MenuItem,
    FormControl, ListItemText, Select, Checkbox, Chip, Dialog,
    DialogContent, DialogActions, DialogTitle, Button, Divider, Avatar, Grid, IconButton
} from "@mui/material";
import download from '../reports/images/download-doc.svg';
import "react-daterange-picker/dist/css/react-calendar.css";
import spinner from '../assign-prescriptions/images/spinner.gif';
import { DesktopDatePicker, LocalizationProvider } from "@mui/lab";
import DateAdapter from "@mui/lab/AdapterDateFns";
import moment from 'moment-timezone';
import { withTranslation } from "react-i18next";
import enLocale from "date-fns/locale/en-US";
import frLocale from "date-fns/locale/fr";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { frFR } from '@mui/material/locale';
import { enUS } from '@mui/material/locale';

const localeTheme = createTheme(
  {
   
  },
  localStorage.getItem('i18nextLng') === 'en' ? enUS : frFR,
);

function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function stableSort(array, cmp) {
    if (array && array.length <= 0) {
        return [];
    }
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = cmp(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
}

function getSorting(order, orderBy) {
    return order === "desc"
        ? (a, b) => desc(a, b, orderBy)
        : (a, b) => -desc(a, b, orderBy);
}
class EnhancedTableHead extends React.Component {
    createSortHandler = property => event => {
        this.props.onRequestSort(event, property);
    };

    render() {
        const { order, orderBy, t } = this.props;
        const rows = [
            { id: "firstname", numeric: false, disablePadding: false, label: t("Patient.History.FirstName"), padding: '2px' },
            { id: "lastname", numeric: false, disablePadding: false, label: t("Patient.History.LastName"), padding: '2px' },
            { id: "store", numeric: false, disablePadding: false, label: t("Patient.History.Store"), padding: '2px' },
            { id: "box", numeric: false, disablePadding: false, label: t("Patient.History.Box"), padding: '2px' },
            { id: "binid", numeric: false, disablePadding: false, label: t("Patient.History.BIN"), padding: '2px' },
            { id: "rxno", numeric: false, disablePadding: false, label: t("Patient.History.RxHash"), padding: '2px' },
            { id: "pucode", numeric: false, disablePadding: false, label: t("Patient.History.PUCode"), padding: '2px' },
            { id: "ndccode", numeric: false, disablePadding: false, label: t("Patient.History.NDCCode"), padding: '2px' },
            { id: "drugname", numeric: false, disablePadding: false, label: t("Patient.History.DrugName"), padding: '2px' },
            { id: "qty", numeric: false, disablePadding: false, label: t("Patient.History.Qty"), padding: '2px' },
            { id: "pickupdate", numeric: false, disablePadding: false, label: t("Patient.History.PickupDate"), padding: '2px' },
        ];

        return (
            <TableHead sx={{ height: '56px' }}>
                <TableRow sx={{ padding: '0 12px' }}>
                    {rows.map(row => {
                        return (
                            <TableCell
                                key={row.id}
                                numeric={row.numeric}
                                padding={row.disablePadding ? "none" : "default"}
                                sortDirection={orderBy === row.id ? order : false}
                                style={{ padding: row.padding }}
                                sx={{ color: 'rgba(0, 0, 0, 0.54)', fontSize: '0.75rem', fontWeight: 500 }}
                            >
                                <Tooltip
                                    title={t("Global.Label.Filter.Sort")}
                                    placement={row.numeric ? "bottom-end" : "bottom-start"}
                                    enterDelay={300}
                                >
                                    <TableSortLabel
                                        active={orderBy === row.id}
                                        direction={order}
                                        onClick={this.createSortHandler(row.id)}
                                    >
                                        {row.label}
                                    </TableSortLabel>
                                </Tooltip>
                            </TableCell>
                        );
                    }, this)}
                </TableRow>
            </TableHead>
        );
    }
}

EnhancedTableHead.propTypes = {
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.string.isRequired,
    orderBy: PropTypes.string.isRequired,
};
EnhancedTableHead = withTranslation()(EnhancedTableHead)


const styles = theme => ({
    root: {
        width: "100%",
    },
    table: {
        minWidth: 1020
    },
    tableWrapper: {
        overflowX: "auto"
    },
    dob: {
        paddingTop: '25px',
    },
    headerdiv: {
        paddingLeft: '15%',
        paddingTop: '10'
    },
    padding10px: {
        padding: '2px !important',
        width: '50px'
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
        maxWidth: 390,
    },
    logoWrapper:
    {
        position: 'absolute',
        width: '89%',
        height: '70%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: 'rgba(255,255,255,0.5)',
        zIndex: '7869'
    },
    spinner: {
        position: 'absolute',
        background: 'rgba(255,255,255,.4)',
        width: '100%',
        height: '100%',
        zIndex: '9999',
        top: 0,
        left: 0,
    },
    spinnerImage: {
        top: 'calc(50% - 32.5px)',
        left: 'calc(50% - 65px)',
        position: 'absolute',
        width: '130px',
        userSelect: 'none'
    },
    hidden: {
        display: 'none'
    }
});

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250,
        },
    },
};
let TransactionFilterObj = {
    store_ids: [],
    box_ids: [],
    searchtext: '',
    fromdate: '',
    todate: ''
}

const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
const findOffset = moment().tz(timeZone).utcOffset();
const defaultZone = `(UTC ${findOffset}) ${timeZone}`;

class PatientHistory extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            order: "desc",
            dob: '',
            orderBy: "created_on",
            page: 0,
            rowsPerPage: 10,
            searchtext: '',
            store_id: [],
            box_id: [],
            fromdate: null,
            todate: null,
            isOpen: false,
            stores: [],
            boxes: [],
            boxvalues: [],
            accountValues: [],
            nstores: [],
            nboxes: [],
            chipstores: [],
            chipboxes: [],
            loader: false,
            selectedObject: null,
            isDataEmpty: true,
            locale: localStorage.getItem('i18nextLng') === 'en' ? enLocale : frLocale
        };
        this.handleStoreChange = this.handleStoreChange.bind(this);
        this.handleBoxChange = this.handleBoxChange.bind(this);
    }

    componentDidMount() {
        this.setState({ loader: true });
        fetch(process.env.REACT_APP_BASEURL + "accounts", {
            method: 'GET',
            withCredentials: true,
            headers: {
                'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                'Content-Type': 'application/json'
            }
        }).then(response => response.json())
            .then(accounts => {
                let All = [{ id: "-1", name: "All" }]
                const storelist = accounts.map(account => {
                    return { id: account.id, name: account.name };
                });
                const accountValues = All.concat(storelist);
                this.setState({ accountValues, parent_account_id: accountValues[0].id });
                this.BindBoxesbyStoreId(storelist.map(x => x.id));
                this.setState({ loader: false });
            });
        this.BindGrid();
    }

    convertToTimeZone = (requestDate) => {
        const currentUserLang = localStorage.getItem('i18nextLng');
        let zone;
        zone = sessionStorage.getItem('timeZone');
        const date = moment(new Date(requestDate));
        if (['null', null, 'undefined', undefined].includes(zone)) {
            zone = defaultZone;
        }
        return currentUserLang === 'en' ? date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('MM/DD/YYYY hh:mm:ss A') : date.tz(zone.substring(zone.lastIndexOf(' ') + 1)).format('DD/MM/YYYY hh:mm:ss A');
    }

    exportCSV() {
        let csvRow = [];
        let A = [['StoreID', 'FirstName', 'LastName', 'Store', 'Box', 'BIN', 'RxNo', 'PickUpCode', 'NDC Code', 'Drug Name', 'Qty', 'Fill Date', 'Pick Up Date']];
        let re = this.state !== null ? this.state.data : [];
        if (re !== undefined) {
            if (re.length > 0) {
                for (let item = 0; item < re.length; item++) {
                    A.push([re[item].firstname,
                    re[item].lastname,
                    re[item].store,
                    re[item].box,
                    re[item].binid,
                    re[item].rxno,
                    re[item].pucode,
                    re[item].ndccode,
                    re[item].drugname,
                    re[item].qty,
                    re[item].filldate ? this.convertToTimeZone(re[item].filldate) : '',
                    re[item].pickupdate ? this.convertToTimeZone(re[item].pickupdate) : '',
                    ]);
                }
                for (let i = 0; i < A.length; ++i) {
                    csvRow.push(A[i].join(","));
                }
                let csvString = csvRow.join("%0A");
                let a = document.createElement("a");
                a.href = 'data:attachment/csv.' + csvString;
                a.target = "_Blank";
                a.download = "PatientHistory.csv";
                document.body.appendChild(a);
                a.click();
            }
        }
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = "desc";
        if (this.state.orderBy === property && this.state.order === "desc") {
            order = "asc";
        }
        this.setState({ order, orderBy });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    BindBoxesbyStoreId(store_ids) {
        if (store_ids.length > 0) {
            this.setState({ loader: true });
            let BoxesObj = {
                store_ids: store_ids
            }
            fetch(process.env.REACT_APP_BASEURL + 'getBoxesByStoreIds', {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(BoxesObj)
            }).then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            }).then(data => {
                let All = [{ id: "-1", name: "All" }]
                const boxlist = data.map(account => {
                    return { id: account.id, name: account.name };
                });
                const boxvalues = All.concat(boxlist);
                this.setState({ chipboxes: [] });
                this.setState({ nboxes: [] });
                this.setState({ boxvalues: boxvalues });
                this.setState({ loader: false });
            });
        }
    }

    handleStoreChange = event => {
        const storeid = event.target.value;
        const storeids = [];
        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = storeid.findIndex(x => x.id === '-1');
        if (event.target.value.length === 1 && AllprocessedIndex > -1) {
            const element = event.target.value[AllprocessedIndex];
            chipprocessed.push(element);
            for (let i = 0; i < this.state.accountValues.length; i++) {
                processed.push(this.state.accountValues[i]);
            }
        } else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
            for (let i = 0; i < this.state.accountValues.length; i++) {
                const element = storeid.findIndex(x => x.id === this.state.accountValues[i].id);
                if (element > -1) {
                }
                else {
                    chipprocessed.push(this.state.accountValues[i]);
                    processed.push(this.state.accountValues[i]);
                }
            }
        } else if (storeid.length === 0 && AllprocessedIndex === -1) {
            chipprocessed = [];
            processed = [];
        } else if (storeid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
                else {

                }
            }
        }
        this.setState({ chipstores: chipprocessed });
        this.setState({ nstores: processed });
        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    storeids.push(processed[i].id)
                }
            }
        }
        this.setState({ store_id: storeids });
        TransactionFilterObj.store_ids = storeids;
        this.BindBoxesbyStoreId(storeids);
        this.BindGrid();
    };

    handleBoxChange = event => {
        const boxid = event.target.value;
        const boxids = [];
        let processed = [];
        let chipprocessed = [];
        const AllprocessedIndex = boxid.findIndex(x => x.id === '-1');
        if (event.target.value.length === 1 && AllprocessedIndex > -1) {
            const element = event.target.value[AllprocessedIndex];
            chipprocessed.push(element);
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                processed.push(this.state.boxvalues[i]);
            }
        } else if (event.target.value.length > 0 && AllprocessedIndex > -1) {
            for (let i = 0; i < this.state.boxvalues.length; i++) {
                const element = boxid.findIndex(x => x.id === this.state.boxvalues[i].id);
                if (element > -1) {
                }
                else {
                    chipprocessed.push(this.state.boxvalues[i]);
                    processed.push(this.state.boxvalues[i]);
                }
            }
        } else if (boxid.length === 0 && AllprocessedIndex === -1) {
            chipprocessed = [];
            processed = [];
        } else if (boxid.length > 0) {
            for (let i = 0; i < event.target.value.length; i++) {
                const element = event.target.value[i];
                if (element.id !== '-1') {
                    chipprocessed.push(element);
                    processed.push(element);
                }
            }
        }
        this.setState({ chipboxes: chipprocessed });
        this.setState({ nboxes: processed });
        if (processed.length > 0) {
            for (let i = 0; i < processed.length; i++) {
                if (processed[i].id !== '-1') {
                    boxids.push(processed[i].id)
                }
            }
        }
        this.setState({ box_id: boxids });
        TransactionFilterObj.box_ids = boxids;
        this.BindGrid();
    };

    onSearchChange = (event) => {
        const searchString = event.target.value;
        this.setState({ searchtext: searchString && searchString });
        TransactionFilterObj.searchtext = searchString;
        this.BindGrid();
    }

    onFromDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ fromdate: date });
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    };

    onToDateSelect = date => {
        date = date ? moment(date).format() : '';
        this.setState({ todate: date });
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    };

    handleBlurfrom = (value, date) => {
        this.setState({
            fromdate: null
        });
        TransactionFilterObj.fromdate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    handleBlurtodate = (value, date) => {
        this.setState({ todate: null });
        TransactionFilterObj.todate = date ? moment(date).format('YYYY-MM-DD') : '';
        this.BindGrid();
    }

    BindGrid() {
        let patientId =  this.props && this.props.patient && this.props.patient.id;
        if(patientId) {
            this.setState({ loader: true, data: null });
            fetch(process.env.REACT_APP_BASEURL + 'getPatientHistoryByPatientID/' + patientId, {
                method: 'post',
                withCredentials: true,
                headers: {
                    'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken.jwtToken,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(TransactionFilterObj)
            }).then(response => {
                try {
                    return response.json();
                } catch (error) {
                    return null;
                }
            }).then(uData => {
                if (uData.length > 0) {
                    this.setState({ data: uData });
                    this.setState({ loader: false, isDataEmpty: false });
                }
                else {
                    this.setState({ data: null });
                    this.setState({ loader: false, isDataEmpty: true });
                }

            });
        }
    }

    handlePUcodeClick = (event, pmid) => {
        event.preventDefault();
        const selectedObject = this.state.data.find(x => x.pmid === pmid);
        this.setState({ detailDialogOpen: true, selectedObject: selectedObject })
    }

    handlePUcodeClose = (event) => {
        event.preventDefault();
        this.setState({ detailDialogOpen: false, selectedObject: null })
    }

    render() {
        const { classes, t } = this.props;
        const { data, order, orderBy, rowsPerPage, page, locale } = this.state;
        return (
            <div>
                {
                    this.state.loader ?
                        <div className={classes.spinner}>
                            <img className={classes.spinnerImage} src={spinner} alt="loading" />
                        </div> : (<div></div>)
                }
                <div>
                    <Dialog
                        open={this.state.detailDialogOpen || false}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        fullWidth={true}
                        maxWidth={'md'}
                    >
                        <DialogTitle id="alert-dialog-title">{t("Patient.History.PickupBy")}</DialogTitle>
                        <DialogContent>
                            <Table aria-labelledby="tableTitle">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.padding10px}>{t("Patient.History.FirstName")}</TableCell>
                                        <TableCell className={classes.padding10px}>{t("Patient.History.LastName")}</TableCell>
                                        <TableCell className={classes.padding10px}>{t("Patient.History.DLNo")}</TableCell>
                                        <TableCell className={classes.padding10px}>{t("Patient.History.Signature")}</TableCell>
                                        <TableCell className={classes.padding10px}>{t("Patient.History.Picture")}</TableCell>
                                        <TableCell className={classes.padding10px}>{t("Patient.History.Relationship")}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        this.state.selectedObject !== null ?
                                            <TableRow>
                                                <TableCell className={classes.padding10px} >{this.state.selectedObject.pfirst_name ? this.state.selectedObject.pfirst_name : ''}</TableCell>
                                                <TableCell className={classes.padding10px}>{this.state.selectedObject.plast_name ? this.state.selectedObject.plast_name : ''}</TableCell>
                                                <TableCell className={classes.padding10px}>{this.state.selectedObject.pdrivers_license_no ? this.state.selectedObject.pdrivers_license_no : ''}</TableCell>
                                                <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0 !important' }} alt="" src={(this.state.selectedObject.psignature_url !== null && this.state.selectedObject.psignature_url !== '') ? this.state.selectedObject.psignature_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                                                <TableCell className={classes.padding10px}><Avatar style={{ borderRadius: '0 !important' }} alt="" src={(this.state.selectedObject.ppicture_url !== null && this.state.selectedObject.ppicture_url !== '') ? this.state.selectedObject.ppicture_url : '/static/dashboard/global_assets/images/placeholders/no-image.svg'} /></TableCell>
                                                <TableCell className={classes.padding10px}>{this.state.selectedObject.relationship ? this.state.selectedObject.relationship.replace('_', ' ').replace('_', ' ') : ''}</TableCell>
                                            </TableRow>
                                            :
                                            <TableRow>
                                                <TableCell colSpan={5}>{t("Patient.History.NoDataFound")}</TableCell>
                                            </TableRow>
                                    }
                                </TableBody>
                            </Table>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={(e) => { this.handlePUcodeClose(e) }} color="primary">
                                {t("Patient.CloseButton")}
                            </Button>
                        </DialogActions>
                    </Dialog>
                    <Grid container spacing={3} style={{paddingBottom:'20px'}}>
                        <Grid item xs={6} sm={4} style={{ paddingRight: '20px' }}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="select-multiple-chip" sx={{ ml: '-3%' }}>{t("Patient.History.Store")}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.chipstores}
                                    onChange={this.handleStoreChange}
                                    input={<Input id="select-multiple-chip" />}
                                    renderValue={selected => (
                                        <div className={classes.chips}>
                                            {selected.map(value => (
                                                <Chip key={value.id} label={value.name} className={classes.chip} />
                                            ))}
                                        </div>
                                    )}
                                    MenuProps={MenuProps}
                                    variant="standard"
                                >
                                    {this.state.accountValues !== undefined && this.state.accountValues.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            <Checkbox checked={this.state.nstores.map(x => x.id).indexOf(item.id) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={4} style={{ paddingRight: '20px' }}>
                            <FormControl fullWidth>
                                <InputLabel htmlFor="select-multiple-chip" sx={{ ml: '-3%' }}>{t("Patient.History.Box")}</InputLabel>
                                <Select
                                    multiple
                                    value={this.state.chipboxes}
                                    onChange={this.handleBoxChange}
                                    input={<Input id="select-multiple-chip" />}
                                    renderValue={selected => (
                                        <div className={classes.chips}>
                                            {selected.map(value => (
                                                <Chip key={value.id} label={value.name} className={classes.chip} />
                                            ))}
                                        </div>
                                    )}
                                    MenuProps={MenuProps}
                                    variant="standard"
                                >
                                    {this.state.boxvalues !== undefined && this.state.boxvalues.map(item => (
                                        <MenuItem key={item.id} value={item}>
                                            <Checkbox checked={this.state.nboxes.map(x => x.id).indexOf(item.id) > -1} />
                                            <ListItemText primary={item.name} />
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                        <Grid item xs={6} sm={4} style={{ paddingRight: '20px' }}>
                            <TextField id="idsearchtxt"
                                defaultValue=""
                                value={this.state.searchtxt}
                                label={t("Patient.History.Search")}
                                onChange={this.onSearchChange}
                                fullWidth
                                inputProps={{
                                    autocomplete: 'new-password',
                                    form: {
                                        autocomplete: 'off',
                                    },
                                }}
                                variant="standard"
                                />
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} style={{paddingBottom:'20px'}}>
                        <Grid item xs={6} sm={4} style={{ paddingRight: '20px' }}>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                <DesktopDatePicker
                                  keyboard
                                  clearable
                                  format="MM/dd/yyyy"
                                  value={this.state.fromdate}
                                  disableFuture
                                  onChange={this.onFromDateSelect}
                                  renderInput={(params) =>
                                      <TextField
                                        {...params}
                                        label={t("Patient.History.FromDate")}
                                        variant="standard"
                                        allowKeyboardControl={true}
                                        onBlur={this.handleBlurfrom}
                                        sx={{ '&.MuiFormControl-root': {width: '21.7rem'} }}
                                      />
                                  }
                                />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6} sm={4} style={{ paddingRight: '20px' }}>
                        <LocalizationProvider dateAdapter={DateAdapter} locale={locale}>
                                <DesktopDatePicker
                                  keyboard
                                  clearable
                                  format="MM/dd/yyyy"
                                  value={this.state.todate}
                                  disableFuture
                                  onChange={this.onToDateSelect}
                                  renderInput={(params) =>
                                      <TextField
                                        {...params}
                                        label={t("Patient.History.ToDate")}
                                        variant="standard"
                                        allowKeyboardControl={true}
                                        onBlur={this.handleBlurtodate}
                                        sx={{ '&.MuiFormControl-root': {width: '21.7rem'} }}
                                      />
                                  }
                                />
                          </LocalizationProvider>
                        </Grid>
                        <Grid item xs={6} sm={4} style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', paddingRight: '20px' }}>
                        <Tooltip key="single-edit" title={t("Patient.History.ExportCSV")}>
                            <IconButton
                              style={{ marginRight: '0'}}
                              aria-label="ExportCSV"
                            >
                            <img alt="download" onClick={() => { this.exportCSV() }} src={download} style={{ height: '32px', width: '32px', cursor: 'pointer' }} />
                            </IconButton>
                        </Tooltip>
                        </Grid>
                    </Grid>
                </div>
                <Divider style={{ marginTop: '10px', height: '5px' }} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle">
                        <EnhancedTableHead
                            order={order}
                            orderBy={orderBy}
                            onRequestSort={this.handleRequestSort}
                        />
                        <TableBody>
                            {!data ?
                                (<TableRow>
                                    <TableCell colSpan={16} style={{ textAlign: "center", padding: '10px 0px' }}>
                                        {this.state.isDataEmpty && t("Patient.History.NoDataFound")}
                                    </TableCell>
                                </TableRow>) : stableSort(data, getSorting(order, orderBy))
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map(n => {
                                        return (
                                            <TableRow>
                                                <TableCell className={classes.padding10px} >{n.firstname}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.lastname}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.store}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.box}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.binid}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.rxno}</TableCell>
                                                <TableCell className={classes.padding10px}><a href='' title="View Pick up by" style={{ color: '#385cad', fontWeight: 500, textDecoration: 'none ', fontSize: '1rem' }} onClick={(event) => this.handlePUcodeClick(event, n.pmid)}> {n.pucode}</a></TableCell>
                                                <TableCell className={classes.padding10px}>{n.ndccode}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.drugname}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.qty}</TableCell>
                                                <TableCell className={classes.padding10px}>{n.pickupdate ? this.convertToTimeZone(n.pickupdate): ''}</TableCell>
                                            </TableRow>
                                        );
                                    })}
                        </TableBody>
                    </Table>
                </div>
                <ThemeProvider theme={localeTheme}>
                    <TablePagination
                        rowsPerPageOptions={[5, 10, 25]}
                        component="div"
                        count={data ? data.length : 0}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        backIconButtonProps={{
                            "aria-label": "Previous Page"
                        }}
                        nextIconButtonProps={{
                            "aria-label": "Next Page"
                        }}
                        onPageChange={this.handleChangePage}
                        onRowsPerPageChange={this.handleChangeRowsPerPage}
                    />
                </ThemeProvider>
            </div>
        );
    }
}

PatientHistory.propTypes = {
    classes: PropTypes.object.isRequired
};

export default withStyles(styles)(withTranslation()(PatientHistory));



// WEBPACK FOOTER //
// ./src/components/patient-list/patientHistory.js